import * as React from 'react';
import { SVGProps } from 'react';

const IconChatStrokedSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m2.936 7.586-.735 2.256 2.134-.686.325.121a4.439 4.439 0 0 0 1.521.294c1.507 0 2.799-.798 3.415-2.076l.013-.028.015-.027C9.877 6.99 10 6.384 10 5.786V5.53A3.799 3.799 0 0 0 6.438 2h-.185c-.589 0-1.134.117-1.602.376l-.012.006-.011.006c-1.334.69-2.122 1.998-2.122 3.398 0 .553.06.974.273 1.448l.157.352ZM6.47 1c2.445.143 4.387 2.071 4.531 4.5v.286c0 .714-.144 1.5-.504 2.143-.79 1.642-2.445 2.642-4.315 2.642a5.435 5.435 0 0 1-1.87-.357L1.866 11h-.144a.655.655 0 0 1-.503-.214c-.216-.215-.288-.5-.144-.715l.791-2.428c-.288-.643-.36-1.214-.36-1.857C1.506 4 2.513 2.357 4.167 1.5c.648-.357 1.367-.5 2.086-.5h.216Z"
    />
  </svg>
);
export default IconChatStrokedSizeXs;
